const mapper = {
    genre: 'tag',
    tag: 'internalTag',
    feeling: 'feeling',
    category: 'category',
    technique: 'technique'
}
export const getCategoryCardDetails = (cardData, cardsType) => {
    const categoryTitle = cardData[mapper[cardsType]]?.name || '';
    const categoryCount = cardData?.count || '';
    const categoryImage = cardData[mapper[cardsType]]?.coverIcon;
    const categoryId = cardData[mapper[cardsType]]?.id;
    const bgColor = cardData[mapper[cardsType]]?.colors;
    return { categoryTitle, categoryCount, categoryImage, bgColor, categoryId };
}

export const getCategoryCardIdToDetailsMap = (categoryList, cardsType) => {

    const categoryIdToDetailMap = new Map();

    categoryList?.forEach((category, index) => {
        categoryIdToDetailMap.set(category[mapper[cardsType]]?.id,
            {
                title: category[mapper[cardsType]]?.name || '',
                count: category?.count || '',
                image: category[mapper[cardsType]]?.coverIcon,
                bgColor: category[mapper[cardsType]]?.colors
            });
    })

    return (categoryIdToDetailMap)

}